import React from "react";
import { AiFillShopping } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

const FloatingCartButton = ({ sellerName, cardProductCount }) => {
  const navigate = useNavigate();

  const redirect_card_page = () => {
    navigate(`/${sellerName}/card`);
  };

  return (
    <div
      onClick={redirect_card_page}
      className="fixed bottom-6 right-6 z-50 group cursor-pointer"
    >
      <div className="relative flex items-center justify-center">
        {/* Animated pulse background */}
        <div className="absolute inset-0 bg-indigo-600 rounded-full animate-ping opacity-20"></div>
        
        {/* Main button */}
        <div className="relative w-14 h-14 bg-indigo-600 hover:bg-indigo-700 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group-hover:scale-110">
          <span className="text-2xl text-white">
            <AiFillShopping />
          </span>
          
          {/* Badge with count */}
          {cardProductCount !== 0 && (
            <div className="absolute -top-2 -right-2 w-7 h-7 bg-red-500 rounded-full text-white flex justify-center items-center text-sm font-bold shadow-md">
              {cardProductCount}
            </div>
          )}
        </div>
        
        {/* Tooltip */}
        <div className="absolute right-full mr-4 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
          <div className="bg-gray-800 text-white text-xs py-2 px-3 rounded-lg shadow-lg">
            View Cart ({cardProductCount} {cardProductCount === 1 ? 'item' : 'items'})
            <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-gray-800"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingCartButton;

